import { Box, Text, getThemeColor } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const IconContainer = styled(Box)`
  width: 48px;
  height: 48px;
  justify-content: center;
  align-items: center;
  border: 1px solid ${({ theme }) => getThemeColor('grey_5', theme)};
  box-shadow: ${({ theme }) => theme.box_shadow.input};
  border-radius: 10px;
`

export const Label = styled(Text)`
  p {
    font-size: 14px;
    color: ${({ theme }) => getThemeColor('grey_3', theme)};
  }
`

export const Value = styled(Text)`
  p {
    font-size: 16px;
    font-weight: 500;
  }
`
